import MessageIcon from '@mui/icons-material/Message';
import { CommentsList } from './CommentsList';
import { CommentsEdit } from './CommentsEdit';

const comments = {
  list: CommentsList,
//   create: CategoryCreate,
  edit: CommentsEdit,
  icon: MessageIcon,
};

export default comments;
